import { useEffect, useState } from "react";

const Timer = ({ className, postedTimeStamp }) => {
  const [time, setTime] = useState({ minutes: 0, seconds: 0 });

  const getTwoDiges = (number) => {
    return number < 10 ? "0" + number : number;
  };

  useEffect(() => {
    if (postedTimeStamp) {
      const interval = setInterval(() => {
        const time = Math.floor(Date.now() / 1000) - postedTimeStamp;

        setTime({
          minutes: Math.floor((time / 60) % 60),
          seconds: Math.floor(time % 60),
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [postedTimeStamp]);

  return (
    <span className={className}>
      {getTwoDiges(time.minutes)}:{getTwoDiges(time.seconds)}
    </span>
  );
};
export default Timer;
